<template>
  <div class="diagramContainer">
    <div class="rackOuterContainer">
     <rack
        v-for="rack in racks"
        :rack="rack"
        :key="rack.ra_id"
        @open-menu="openMenu"
        @open-rack-menu="openRackMenu"
        @set-active-position="setActivePosition"
        @start-drag="startDrag"
        @end-drag="endDrag"
      />
    </div>
    <div class="rackBtnsContainer">
      <v-btn :disabled="disabled" @click="openForm" class="rackBtn">
        <v-icon color="white">add</v-icon>
      </v-btn>
      <v-btn :disabled="disabled" @click="save" class="rackBtn">
        <v-icon color="white">save</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
  import Rack from './Rack.vue';
  export default {
    name: "InsidePlanDiagram",
    components: {
      Rack
    },
    props: {
      racks: {
        type: Array,
      },
      disabled: {
        type: Boolean
      }
    },
    data() {
      return {
      };
    },
    computed: {

    },
    methods: {
      openForm(){
        this.$emit('open-form', "rack", "add");
      },
      save(){
        this.$emit('save-drawer-changes');
      },
      openMenu(horizontal, vertical, isEmptyPosition, position){
        this.$emit('open-menu', horizontal, vertical, isEmptyPosition, position);
      },
      openRackMenu(horizontal, vertical, rack){
        this.$emit('open-rack-menu', horizontal, vertical, rack);
      },
      setActivePosition(obj){
        this.$emit('set-active-position', obj);
      },
      startDrag(e, position){
        this.$emit('start-drag', e, position);
      },
      endDrag(e, position){
        this.$emit('end-drag', e, position);
      }
    }
  }
</script>

<style scoped>
  .diagramContainer{
    background-color: #eae7e7;
    height: calc(100% - 152px);
    width: 100%;
    display: flex;
    border-radius: 10px;
    padding: 20px 20px 20px 40px;
  }
  .rackOuterContainer{
    height: 100%;
    width: calc(100% - 50px);
    display: flex;
    gap: 100px;
    padding-bottom: 10px;
    overflow-x: scroll;
  }
  .rackBtn{
    min-width: 30px !important;
    height: 30px !important;
    padding: 0 !important;
    margin-left: 20px;
    margin-bottom: 10px;
    background-color: #4fa2b7 !important;
  }
  .rackBtnsContainer{
    width: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/InsidePlanDiagram.vue